// Garde-fou global : plus jamais de page blanche. Après un déploiement, un onglet resté ouvert peut charger
// un ancien « chunk » (ChunkLoadError) → rechargement automatique une fois. Toute autre erreur affiche un
// écran clair avec bouton « Recharger » au lieu d'un écran vide.
import { Component } from "react";

const isChunkError = (e) => /ChunkLoadError|Loading chunk|Loading CSS chunk|dynamically imported module|Importing a module script failed/i.test(`${e?.name} ${e?.message}`);

export class RouteErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    if (isChunkError(error)) {
      const key = "chunk_reload_" + window.location.pathname;
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, "1");
        window.location.reload();
        return;
      }
    }
    // eslint-disable-next-line no-console
    console.error("[RouteErrorBoundary]", error);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const chunk = isChunkError(this.state.error);
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900 p-6" data-testid="route-error-boundary">
        <div className="max-w-md w-full rounded-2xl bg-white p-6 shadow-xl text-center space-y-3">
          <h1 className="text-xl font-bold text-slate-900">{chunk ? "Nouvelle version disponible" : "Un problème d'affichage est survenu"}</h1>
          <p className="text-sm text-slate-600">{chunk ? "L'application a été mise à jour pendant votre session. Rechargez la page pour continuer." : "La page n'a pas pu s'afficher correctement. Rechargez la page ; si le problème persiste, revenez à l'administration."}</p>
          {!chunk && <p className="text-[11px] text-slate-400 break-words">{String(this.state.error?.message || this.state.error).slice(0, 200)}</p>}
          <div className="flex gap-2 justify-center">
            <button type="button" onClick={() => window.location.reload()} className="rounded-md bg-[#FF6B00] text-white px-4 py-2 text-sm font-semibold" data-testid="route-error-reload">Recharger la page</button>
            <a href="/admin" className="rounded-md border px-4 py-2 text-sm font-semibold text-slate-700" data-testid="route-error-admin">Retour à l'admin</a>
          </div>
        </div>
      </div>
    );
  }
}
